/**
 * ClusterService
 * --------------------------------------------
 * --------------------------------------------
 *
 * Controlador que tiene los endpoints de los Clusters.
 *
 * Endpoints:
 * ------------------
 * 1.  GET    ->  {ENDPOINT_PATH}
 *
 */

import axios from "axios";
import { getAuthToken } from "@/utils/AuthService.js";

const ENDPOINT_PATH = " http://urbanbrain.siarq.com:8080/cluster/";

/** 1. Endpoint getAlarms
 * ------------------------------------------------------------------------------
 * Obtiene todos los clusters del usuario.
 *
 * url: {ENDPOINT_PATH}
 *
 * method: GET
 *
 * type: JSON
 *
 */
export function getClustersUser() {
  return new Promise(async (resolve, reject) => {
    try {
      let cluster = await axios({
        url: `${ENDPOINT_PATH}`,
        method: "GET",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(cluster.data);
    } catch (err) {
      console.error("Caught an error during login:", err);
      reject(err);
    }
  });
}
